import React from "react";
import {
  BaseModal,
  BaseModalBody,
  BaseModalHeader,
} from "@src/common/components";
import { SIZE } from "baseui/modal";
import { CustomLocationProvider } from "./context";
import { LocationForm, LocationMap } from "./components";
import { CustomLocationModalProps } from "./types";

const CustomLocationModal: React.FC<CustomLocationModalProps> = ({
  isModalOpen,
  onClose,
  onSuccess,
  title = "Set Custom Location",
  submitButtonText = "Use This Location",
}) => {
  return (
    <BaseModal
      isOpen={isModalOpen}
      onClose={onClose}
      size={SIZE.auto}
      autoFocus={false}
      returnFocus={false}
    >
      <BaseModalHeader>{title}</BaseModalHeader>
      <BaseModalBody>
        <CustomLocationProvider
          onClose={onClose}
          onSuccess={onSuccess}
          submitButtonText={submitButtonText}
        >
          <div className="grid grid-cols-3 gap-4 min-w-[70vw] h-[70vh]">
            <LocationForm />
            <LocationMap />
          </div>
        </CustomLocationProvider>
      </BaseModalBody>
    </BaseModal>
  );
};

export default CustomLocationModal;
